module.exports = __webpack_public_path__ + "img/_img_arrow_right.46be7af8.svg";